import type { Module } from 'owa-workloads-module';
import { action } from 'satcheljs';

export interface UpdateModuleActionMessage {
    newModule: Module;
    currentModule: Module | undefined;
}
const defaultExport: (newModule: Module, currentModule?: Module) => UpdateModuleActionMessage =
    action(
        'updateModule',
        (newModule: Module, currentModule?: Module): UpdateModuleActionMessage => ({
            newModule,
            currentModule,
        })
    );
export default defaultExport;
